// GoogleAnalytics.tsx

import React, { useEffect } from 'react';

const GoogleAnalytics = () => {
    useEffect(() => {
        // Load Google Analytics script
        const script1 = document.createElement('script');
        script1.src = 'https://www.googletagmanager.com/gtag/js?id=G-BBM3ELB6JC';
        script1.async = true;
        document.head.appendChild(script1);

        // Initialize Google Analytics
        const script2 = document.createElement('script');
        script2.innerHTML = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-BBM3ELB6JC', {
                page_path: window.location.pathname,
            });
        `;
        document.head.appendChild(script2);

        // Cleanup
        return () => {
            document.head.removeChild(script1);
            document.head.removeChild(script2);
        };
    }, []);

    return null;
};

export default GoogleAnalytics;
